import { Region } from '@dispatch/shared/types';
import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';

enum ErrorsTypes {
  DUPLICATE_STATE = 'duplicateState',
  DUPLICATE_NAME = 'duplicateName',
}

export const validateRegion = (
  value: Partial<Region>,
  allRegions: Region[],
  notifyError: (
    title: string,
    message: SnackbarMessage,
    options?: OptionsObject | undefined
  ) => SnackbarKey
): boolean => {
  const newStates: string[] = value?.states || [];

  const errors: string[] = [];
  const checkErrors = allRegions?.map((region: Region) => {
    const currentStates: string[] = region?.states || [];
    let hasError = false;

    currentStates.forEach((state: string) => {
      if (newStates.includes(state) && region.id !== value.id) {
        // check to insure only one snackbar shows.
        if (!errors.includes(ErrorsTypes.DUPLICATE_STATE)) {
          errors.push(ErrorsTypes.DUPLICATE_STATE);
          notifyError(
            `Duplicate State`,
            `${state} is already in the ${region?.name} region`
          );
        }

        hasError = true;
      }
    });

    if (region.name === value?.name && region.id !== value.id) {
      // check to insure only one snackbar shows.
      if (!errors.includes(ErrorsTypes.DUPLICATE_NAME)) {
        errors.push(ErrorsTypes.DUPLICATE_NAME);
        notifyError(
          'Duplicate Name',
          `A region by the name of ${value?.name} already exists`
        );
      }

      hasError = true;
    }

    return hasError;
  });

  return checkErrors.includes(true);
};
